module.exports = __webpack_public_path__ + "img/aguaixtapandelasal.58c3da9f.jpg";